import { writable } from 'svelte/store';

export const timer = writable(0);
export const endurance_start_time = writable(0);
export const is_game_over = writable(0);
export const timer_started = writable(0);
